/* eslint-disable */
import { permissionsMessages } from '@ringcentral-integration/commons/enums/permissionsMessages';
export default {
  [permissionsMessages.callingDisable]:
    '您没有权限拨出电话。请联系您的 {brand} 帐户管理员进行升级。',
} as const;

// @key: @#@"[permissionsMessages.callingDisable]"@#@ @source: @#@"You don't have permissions to place outbound calls. Please contact your {brand} account administrator for an upgrade."@#@
